export const getRouteMain = () => '/';
export const getRouteMyWorks = () => '/works';
export const getRouteInformation = () => '/information';
export const getRouteContact = () => '/contact';


export const getRouteFamily = () => '/family';
export const getRouteWedding = () => '/wedding';
export const getRouteKids = () => '/kids';
export const getRouteWoman = () => '/woman';
export const getRouteWinter = () => '/winter';
export const getRoutePregnancy = () => '/pregnancy';
export const getRouteNewYear = () => '/newyear';
export const getRouteNewborn = () => '/newborn';
export const getRouteLoveStory = () => '/lovestory';
export const getRouteDaughter = () => '/daughter';
export const getRouteBirthday = () => '/birthday';
export const getRouteChrist = () => '/christ';
